import { createFetchAndCacheAtom, createFetchAndCacheAtomWithKey } from '@mostrans/web-components/helpers/atomHelpers';


export const DetaiTestimonialAtom = createFetchAndCacheAtomWithKey([]);
export const MasterTestimonialAtom = createFetchAndCacheAtom([])
export const MasterTestimonialForPublicAtom = createFetchAndCacheAtom([])